import * as msal from "@azure/msal-browser";

// Configuration object
export const msalConfig = {
    auth: {
        clientId: <string>process.env.VUE_APP_AZURE_AD_CLIENT_ID,
        authority: <string>process.env.VUE_APP_AZURE_AD_AUTHORITY,
        redirectUri:
            <string>process.env.VUE_APP_AZURE_AD_REDIRECT_URI ??
            window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage", // Recommended for security in SPAs
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            piiLoggingEnabled: false,
            logLevel: msal.LogLevel.Info
        }
    }
};
